export default {
      id: "filter-usage",
      viewBox: "0 0 16 17",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#filter",
      toString: function () {
        return this.url;
      }
    }